/**
 *
 * PortalAppNavigation
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 26-Oct-2022
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import LogoDark from 'Assets/images/logo/logo_dark.svg';
import LogoLight from 'Assets/images/logo/logo_light.svg';
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';

const PortalAppNavigation = (props) => {
	const location = useLocation();
	let navigate = useNavigate();

	const path = location && location.pathname ? location.pathname.split('/')[1] : '/';

	const [activeRoute, setActiveRoute] = useState(path);

	const handleSetRoute = (route, state) => {
		navigate(`/${route}`);
		setActiveRoute(state);
	};

	useEffect(() => {
		setActiveRoute(path);
	}, [path]);

	return (
		<>
			<DesktopMenu
				path={path}
				brand={props.brand}
				logo={props.logo}
				logoLight={LogoLight}
				logoDark={LogoDark}
				logged={props.logged}
				handleSetRoute={handleSetRoute}
				activeRoute={activeRoute}
				setActiveRoute={setActiveRoute}
				permittedRoutes={props.permittedRoutes}
			/>
			<MobileMenu
				path={path}
				brand={props.brand}
				logo={props.logo}
				logoLight={LogoLight}
				logoDark={LogoDark}
				logged={props.logged}
				handleSetRoute={handleSetRoute}
				activeRoute={activeRoute}
				setActiveRoute={setActiveRoute}
				permittedRoutes={props.permittedRoutes}
			/>
		</>
	);
};

PortalAppNavigation.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	brand: PropTypes.string,
	logo: PropTypes.object,
	logged: PropTypes.bool.isRequired,
	permittedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

PortalAppNavigation.defaultProps = {
	// Add here some default propTypes values
	brand: '',
	logo: {},
	permittedRoutes: ['Home'],
};

export default PortalAppNavigation;
